<template>
  <v-container
    class="pa-0"
  >
    <v-card
      v-if="form"
      tile
      flat
      class="pa-3 pt-0"
    >
      <s-person-info-toolbar />

      <div class="section-header">
        <span>1. {{ $t('HR.IdentityData') }}</span>
      </div>

      <v-row
        class="my-2"
        dense
      >
        <v-col
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('HR.ChinName') }}: <v-spacer class="d-md-none" /> {{ form.chinName }}
        </v-col>
        <v-col
          cols="12"
          md="8"
          class="d-flex"
        >
          {{ $t('HR.PortName') }}: <v-spacer class="d-md-none" /> {{ form.portName }}
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('PublicServant.Me.PersonalInfo.BirthDate') }}:<v-spacer class="d-md-none" /> {{ momentWithHyphen(form.birthDate).format('YYYY-MM-DD') }}
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('PublicServant.Personal.Credentials.IdentityDocType') }}: <v-spacer class="d-md-none" /> {{ $chPtObjData('chinIdentityDocTypeDesc', form) }}
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('HR.IdCardNo') }}: <v-spacer class="d-md-none" />{{ maskDocNum }}
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('HR.Nation') }}: <v-spacer class="d-md-none" />{{ $chPtObjData('chinNationalityDesc', form) }}
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('HR.BirthPlace') }}: <v-spacer class="d-md-none" />{{ $chPtObjData('chinBirthPlaceDesc', form) }}
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('HR.Gender') }}: <v-spacer class="d-md-none" />{{ $chPtObjData('chinSexDesc', form) }}
        </v-col>
      </v-row>

      <div class="section-header">
        <span>2. {{ $t('HR.CareerStatus') }}</span> <!-- 職業狀況 -->
      </div>

      <v-row
        v-for="(post, index) in form.posts"
        :key="'post-' + index"
        class="my-2"
        dense
      >
        <v-col
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('HR.CategoryOrOfficial') }}: <v-spacer class="d-md-none" />{{ position(post) }}
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('HR.Vinculum') }}: <v-spacer class="d-md-none" />{{ $chPtObjData('chinVinculumTypeDesc', post) }}
        </v-col>
        <v-col
          v-if="post.salaryIndex"
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('HR.SalaryIndex') }}: <v-spacer class="d-md-none" />{{ post.salaryIndex }}
        </v-col>
        <v-col
          v-if="post.salary"
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('HR.SalaryMop') }}: <v-spacer class="d-md-none" />{{ post.salary }}
        </v-col>
      </v-row>

      <div class="section-header">
        <span>3. {{ $t('HR.LangUpdate') }}</span>
      </div>

      <v-simple-table>
        <v-col
          cols="12"
          md="6"
        >
          <v-simple-table class="mb-2">
            <thead>
              <tr>
                <th class="text-xs-left">
                  {{ $t('HR.Lang') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('HR.MotherLang') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('HR.Writing') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('HR.Speech') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="lang in form.languages"
                :key="lang.languageTypeId"
              >
                <td>{{ $chPtObjData('chinLanguageTypeDesc', lang) }}</td>
                <!-- TODO: handle i18n -->
                <td>{{ lang.isMotherLang ? $t('Text.True') : $t('Text.False') }}</td>
                <td>{{ $chPtObjData('chinWriteLevelDesc', lang) }}</td>
                <td>{{ $chPtObjData('chinSpeakLevelDesc', lang) }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-simple-table>

      <div class="section-header">
        <span>4. {{ $t('HR.Education') }}</span>
      </div>

      <v-row
        v-for="(education, index) in form.educations"
        :key="'edu-' + index"
        class="my-2"
        dense
      >
        <v-col
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('HR.Education.Highest') }}: <v-spacer class="d-md-none" />{{ $chPtObjData('chinEducationLevelTypeDesc', education) }}
        </v-col>
        <v-col
          cols="12"
          md="8"
          class="d-flex"
        >
          {{ $t('HR.teachingLanguage') }}: <v-spacer class="d-md-none" />{{ $chPtObjData('chinLanguageTypeDesc', education) }}
        </v-col>

        <v-col
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('HR.Major') }}: <v-spacer class="d-md-none" />{{ education.eduTitle }}
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('HR.Education.InstituteName') }}: <v-spacer class="d-md-none" />
          <template v-if="education.eduInstitutionId !== 0">
            {{ $chPtObjData('chinEduInstitutionDesc', education) }}
          </template>
          <template v-else>
            {{ $chPtObjData('eduInstitutionSupplement', education) }}
          </template>
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="d-flex"
        >
          {{ $t('HR.Education.GradPlace') }}: <v-spacer class="d-md-none" />{{ $chPtObjData('chinEduCertIssuePlaceDesc', education) }}
        </v-col>
      </v-row>
      <v-btn
        color="primary ml-0"
        @click="dialog = true"
      >
        {{ $t('HR.UpdateData') }}
      </v-btn>
      <s-message-dialog
        :message="$t('HR.Dialog.Msg')"
        :show.sync="dialog"
      />
    </v-card>
  </v-container>
</template>

<script>

import { momentWithHyphen } from '@/utils/datetimeUtil'
import SPersonInfoToolbar from './components/SPersonInfoToolbar'
import SMessageDialog from '../../components/SMessageDialog'
// import bdrhApi from '../../api/hr/bdrh'
import bdrhStaff from '../../store/modules/hr/bdrhStaff'
import store from '../../store'
import { mapState } from 'vuex'
import { bdrhStaffModule } from '../../store/moduleName'
import { maskMiddle } from '../../utils/stringUtil'

if (!store.state[bdrhStaffModule]) store.registerModule(bdrhStaffModule, bdrhStaff)

export default {
  components: {
    SPersonInfoToolbar,
    SMessageDialog
  },
  data: function () {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapState({
      form: state => state[bdrhStaffModule].info,
      maskDocNum: state => maskMiddle(state[bdrhStaffModule].info.docNum)
    })
  },
  created () {
    this.$store.dispatch(bdrhStaffModule + '/getStaff')
    // bdrhApi.getStaff(staff => {
    //   this.form = staff
    // })
  },
  methods: {
    position: function (post) {
      if (post.chinOfficialTypeTitle) {
        return this.$chPtObjData('chinOfficialTypeTitle', post)
      } else {
        return this.$chPtObjData('chinCategoryScaleDescForDisplay', post)
      }
    },
    momentWithHyphen: momentWithHyphen
  }
}
</script>
